import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { Img } from '@euler/components/image/AdvancedImage';
import { TouchableOpacity, View } from 'react-native';
import { useResponsiveContext } from '../../functions/responsive/ResponsiveContext';
import { SnackbarBase } from './Snackbar';
import { SnackbarStyles, useSnackbarStylePresets } from './styles-presets';

type NotificationProps = {
  title: string;
  /** can specify an image to be displayed on left side */
  image?: string;
  /** a close button will be show when specified as true */
  closable?: boolean;
  /** allow customize the look & feel of the bar */
  styles?: SnackbarStyles;
  /** action buttons for the bar */
  actions?: { title: string; onPress?: () => void }[];
  /** allow responding to bar press */
  onPress?: () => void;
  onDismiss?: () => void;
};

export const Notification = ({ styles, ...props }: NotificationProps) => {
  const { rpx } = useResponsiveContext();
  const presets = useSnackbarStylePresets();
  return (
    <SnackbarBase styles={styles} {...props}>
      <View
        css={`
          flex-direction: row;
          align-items: center;
          min-height: ${rpx(44)}px;
          background-color: white;
        `}
        style={[presets.default.contentContainer, styles?.contentContainer]}
      >
        {props.image ? (
          <View
            style={[presets.default.imageContainer, styles?.imageContainer]}
          >
            <Img
              uri={props.image}
              style={[presets.default.image, styles?.image]}
            />
          </View>
        ) : null}
        <Typography.Label
          color="#000"
          lineHeight={rpx(14)}
          css={`
            flex: 1;
          `}
          style={[presets.default.text, styles?.text]}
        >
          {props.title}
        </Typography.Label>
        {props.actions?.map((action, index) => (
          <TouchableOpacity
            key={index}
            css={`
              align-self: stretch;
              justify-content: center;
              margin-left: ${rpx(5)}px;
            `}
            onPress={() => {
              props.onDismiss?.();
              action.onPress?.();
            }}
          >
            <Typography.Label color={'#000'}>{action.title}</Typography.Label>
          </TouchableOpacity>
        ))}
        {props.closable && (
          <TouchableOpacity
            onPress={props.onDismiss}
            style={[
              presets.default.closeButton?.style,
              styles?.closeButton?.style,
            ]}
            hitSlop={{ left: 8, right: 8, top: 8, bottom: 8 }}
          >
            <Icon
              name="closecircle"
              size={
                styles?.closeButton?.size ??
                presets.default.closeButton?.size ??
                rpx(12)
              }
              color={
                styles?.closeButton?.color ??
                presets.default.closeButton?.color ??
                'black'
              }
            />
          </TouchableOpacity>
        )}
      </View>
    </SnackbarBase>
  );
};
